<template>
	<el-dialog
  title=""
  :visible.sync="dialogVisible"
  width="420px"
  :before-close="handleClose">
<div>
	<div v-if="parames.ptw">
		<div class="bold font16 m-b-10"> 🔑口令/链接</div>
		<div class="ptw-content m-b-10">{{ parames.ptw }}</div>
		<el-button class="copy-button" @click="copy">复制口令/链接</el-button>
	</div>
	<div v-if="parames.pageUrl" :class="{'m-t-20': parames.ptw}">
		<div class="bold font16 m-b-10">🔗链接</div>
		<div class="ptw-content m-b-10">{{ parames.pageUrl }}</div>
		<el-button class="open-link-button" type="primary" @click="openPage">打开链接</el-button>
		<el-button class="copy-link-button" type="success" @click="copyLink">复制链接</el-button>
	</div>
</div>
</el-dialog>
</template>

<script>
export default {
	props: {
		isShow: {
			type: Boolean,
			default: false
		},
		parames: {
			type: Object,
			default: () => ({})
		}
	},
	computed: {
		dialogVisible: {
			get() {
				return this.isShow
			},
			set(val) {
				
			}
		},
	},
	data () {
		return {
		}
	},
	methods: {
		copy() {
			this.$copyText(this.parames.ptw).then(() => {
				this.handleClose()
                this.$message.success('复制成功')
            }, () => {
                this.$message.error('复制失败，请自行选中复制')
            })
		},
		copyLink() {
			this.$copyText(this.parames.pageUrl).then(() => {
				this.handleClose()
				this.$message.success('复制成功')
			}, () => {
				this.$message.error('复制失败，请自行选中复制')
			})
		},
		openPage() {
			this.handleClose()
			window.open(this.parames.pageUrl, '_blank')
		},
		handleClose() {
			this.$emit('close')
		}
	}
}
</script>

<style scoped lang="scss">
::v-deep .el-dialog__header {
	padding: 0
}

.ptw-content {
	padding:10px 20px;
	background-color: #f5f5f5;
	border-radius: 4px;
}
.copy-button{
	width: 100%;
}
.open-link-button{
	width: 100%;
	margin-bottom: 10px;
}
.copy-link-button{
	width: 100%;
	margin-left: 0!important;
}
</style>
